// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-goal-group-drawer .group-name{font-size:16px;margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
